/**
 * BACK-COMPAT SHIM. The provider + hooks live in `@/lib/flags/client`.
 * Existing imports keep working through this re-export.
 */
export {
  FlagsProvider,
  useFlag,
  useFlags,
  useSection,
  useAudiences,
  useHasAudience,
} from "./flags/client";
